// extracted by mini-css-extract-plugin
export default {"toc":"p_bx","h3toc":"p_by","linkText":"p_bz","tocTitle":"p_bB"};